import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b01122a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b01122a')) {
      api.createRecord('5b01122a', component.options)
    } else {
      api.reload('5b01122a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5b01122a", function () {
      api.rerender('5b01122a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/historyManage/index.vue"
export default component.exports